import { AnimatePresence, motion } from "framer-motion"
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from "../ui/table"
import { Loader } from "components/Loader/Loader"
// import { Paginator } from "primereact/paginator"
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { DataTable as PrimeDataTable } from "primereact/datatable"
import { Column } from "primereact/column";
import { useLangContext } from "context/Lang";
import { Message } from "primereact/message";


export interface TableCol<T> {
  label: string
  name?: keyof T
  cell?: (row: T) => React.ReactNode
}

interface DataTableProps<T> {
  data: T[]
  columns: TableCol<T>[]
  rowKey: (row: T) => string | number
  loading?: boolean,
  totalRecords?: number;
  rows?: number;
  first?: number;
  onPageChange?: (event: PaginatorPageChangeEvent) => void;
}

export function DataTable<T>({
  data,
  columns,
  rowKey,
  loading,
  totalRecords = 0,
  rows = 10,
  first = 0,
  onPageChange

}: DataTableProps<T>) {

  const { gW } = useLangContext();


  return (
    <div className="rounded-lg border  ">

      <PrimeDataTable
        loading={loading}

        emptyMessage={<div className=" w-full " > <Message className=" w-full " text={gW("no-records")} /> </div>}

        value={data as unknown as any[] || undefined}
        // expandedRows={expandedRow}
        // onRowExpand={onRowExpand}
        // onRowCollapse={onRowExpand}

        dataKey="id"
        className=" border  rounded-lg overflow-hidden "
        // filters={filters}
        paginator
        rowsPerPageOptions={[5, 10, 20, 50]}
        rows={10}


      >
        {/* <Column expander={true} style={{ width: '3rem' }} /> */}

        {columns?.map((col, index) => {

          return <Column
            key={index}
            field={(col.name as string) + ""} header={col.label}
            // sortable
            filter
            body={col.cell}
          // filterElement={renderColumnFilter('username')}
          />
        })}

        {/* <Column field="surname" header="Soyad"  /> */}
      </PrimeDataTable>
      {/* <Table className=" overflow-hidden " >
        <TableHeader>
          <TableRow className=" ">
            {columns.map((col, i) => (
              <TableHead key={i} className="font-semibold text-start">
                {col.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody>
          <AnimatePresence>
            {data?.slice(first, first + rows).map((row) => (
              <motion.tr
                key={rowKey(row)}
                initial={{ opacity: 0, y: 5 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                className="hover:bg-background-secondary transition-colors border-b border-border"
              >
                {columns.map((col, i) => (
                  <TableCell key={i}>
                    {col.cell
                      ? col.cell(row)
                      : (row as any)[col.name as string]}
                  </TableCell>
                ))}
              </motion.tr>
            ))}
          </AnimatePresence>
        </TableBody>
      </Table> */}





    </div>
  )
}